import * as ng from 'angular';
import * as _ from 'underscore';

import { L10nService } from './l10n.service';

export class LanguagesController {
   static $inject = ['l10n'];

   constructor(l10n:L10nService) {
      let langs = l10n.getLanguages();
      this.mainLanguages = _.object(
         _.pluck(langs, 'code'),
         _.pluck(langs, 'nameEnglish')
      );
   }

   readonly mainLanguages:{ [key: string]: string };

   languages:string[];
   defaultLanguage:string;

   canAdd() {
      return _.keys(this.mainLanguages).length > this.languages.length;
   }

   remaining() {
      return _.omit(this.mainLanguages, this.languages);
   }

   add(langCode) {
      if (!_.contains(this.languages, langCode)) {
         this.languages.push(langCode);
      }
   }

   remove(langCode:string) {
      this.languages = _.without(this.languages, langCode);
      if (this.defaultLanguage === langCode) {
         this.defaultLanguage = this.languages[0];
      }
   }
}

ng.module('e360').component('languages', {
   templateUrl: require('./languages.html'),
   controller: LanguagesController,
   bindings: {
      languages: '=',
      defaultLanguage: '='
   }
});
